import React from 'react';
import { identifyComponent } from '../../../util';
import { TableHeadRowBase as TableHeadRowBaseType } from './types';

export const TableHeadRowBase: TableHeadRowBaseType = ({ children, className, ...rest }) => (
  <tr
    data-component="TableHeadRowBase"
    className={className}
    {...rest}
    {...identifyComponent('table-head-row-base', rest)}
  >
    {children}
  </tr>
);
